import React, { useEffect, useState } from 'react';
import PaymentHxPopup from './PaymentHxPopup';
import { Link } from 'react-router-dom';
import ReactDatePicker from 'react-datepicker';
import { DEFAULT_DATE_FORMATE } from '../../../constents';
import { format } from 'date-fns';
import AddPaymentPopup from './AddPaymentPopup';
import setUiMessage from '../../../Utilities/Tostify';

function TakePaymentPopUp({ closePopup }) {
  const [paymentHxPopup, setPaymentHxPopup] = useState(false);
  const [addPaymentPopup, setAddPaymentPopup] = useState(false);
  const [dos, setDos] = useState('');
  const [paymentDate, setPaymentDate] = useState('');
  const [addPaymentArr, setAddPaymentArr] = useState({});
  const [mode, setMode] = useState('1');
  const [check, setCheck] = useState('');
  const [charges, setCharges] = useState(0.0);
  const [amount, setAmount] = useState(0.0);
  const [dueAmount, setDueAmount] = useState(0.0);
  const [forDoc, setForDoc] = useState(false);
  const [remark, setRemark] = useState('');
  const [billType, setBillType] = useState('0');
  const [cardMode, setCardMode] = useState('0');
  const [unit, setUnit] = useState('1');
  const [payAmount, setPayAmount] = useState('');
  const [servicesPopup, setServicesPopup] = useState(false);
  const [paymentFor, setPaymentFor] = useState('');
  const [serviceTextVal, setServiceTextVal] = useState('');
  const [dueAmountTxt, setDueAmountTxt] = useState('');

  const dosArr = [
    '',
    '02-05-2023(Office)',
    '02-02-2023 (Lab)',
    '01-25-2023 (Lab)',
    '10-10-2023(Office)',
  ];

  const allData = {
    dos: '',
    paymentDate: '',
    paymentFor: '',
    chargers: '',
    mode: '',
    check: '',
    amount: '',
    due: '',
  };

  useEffect(() => {
    const difference = charges - amount;
    setDueAmount(difference);
  }, [charges, amount]);

  const handlePaymentHxPopup = () => {
    setPaymentHxPopup(true);
  };

  const handleDateChange = (date) => {
    const formattedDate = format(date, DEFAULT_DATE_FORMATE);
    setPaymentDate(formattedDate);
  };

  const formatPayment = (value) => {
    let formattedValue = value.trim();
    // Check if the entered value is already formatted correctly
    const isFormatted = /^(\$[0-9]+(\.[0-9]{2}))$/.test(formattedValue);
    if (!isFormatted) {
      // Check if the entered value starts with '$' and has numeric value with no decimal
      if (/^\$[0-9]+$/.test(formattedValue)) {
        formattedValue += '.00';
      } else if (/^\$[0-9]+\.$/.test(formattedValue)) {
        // Check if the entered value starts with '$' and has decimal
        formattedValue += '00';
      } else if (/^\$[0-9]+\.\d$/.test(formattedValue)) {
        // Check if the entered value starts with '$' and has one decimal place
        formattedValue += '0';
      } else if (/^\$[0-9]+\.\d{2,}$/.test(formattedValue)) {
        // Check if the entered value starts with '$' and has more than two decimal places
        formattedValue = `$${parseFloat(formattedValue.slice(1)).toFixed(2)}`;
      } else if (/^[0-9]+(\.\d*)?$/.test(formattedValue)) {
        // Check if the entered value starts with numeric value
        formattedValue = `$${parseFloat(formattedValue).toFixed(2)}`;
      } else {
        formattedValue = ''; // Invalid input
      }
    }
    // if (!isFormatted) {
    //   // Check if the entered value starts with '$' and has numeric value with no decimal
    //   if (/^\$[0-9]+$/.test(formattedValue)) {
    //     formattedValue = `${formattedValue}.00`;
    //   } else if (/^\$[0-9]+\.$/.test(formattedValue)) {
    //     // Check if the entered value starts with '$' and has one decimal place
    //     formattedValue = `${formattedValue}00`;
    //   } else if (/^\$[0-9]+\.\d$/.test(formattedValue)) {
    //     // Check if the entered value starts with '$' and has one decimal place
    //     formattedValue = `${formattedValue}0`;
    //   } else if (/^\$[0-9]+\.\d{2,}$/.test(formattedValue)) {
    //     // Check if the entered value starts with '$' and has more than two decimal places
    //     formattedValue = formattedValue.slice(1);
    //     formattedValue = `$${parseFloat(formattedValue).toFixed(2)}`;
    //   } else if (/^[0-9]+(\.\d*)?$/.test(formattedValue)) {
    //     // Check if the entered value starts with numeric value
    //     formattedValue = `$${parseFloat(formattedValue).toFixed(2)}`;
    //   } else {
    //     // If not numeric, set the input value to an empty string
    //     formattedValue = '';
    //   }
    // }
    return formattedValue;
  };

  const handleChargesBlur = (event) => {
    const enteredValue = event.target.value;
    const formattedValue = formatPayment(enteredValue);
    // Update the input value
    event.target.value = formattedValue;
    // Set amount state based on formatted value
    setCharges(formattedValue ? parseFloat(formattedValue.slice(1)) : 0.0);
    setDueAmountTxt(formattedValue ? formattedValue : '');
  };

  const handleAmountBlur = (event) => {
    const enteredValue = event.target.value;
    const formattedValue = formatPayment(enteredValue);
    // Update the input value
    event.target.value = formattedValue;
    // Set amount state based on formatted value
    setAmount(formattedValue ? parseFloat(formattedValue.slice(1)) : 0.0);
    setPayAmount(formattedValue ? formattedValue : '');
  };

  const handleAddPaymentPopup = () => {
    setAddPaymentPopup(true);
  };

  const handleSave = () => {
    if (dos === '') {
      setUiMessage('err', 'Date of service is not selected!');
    } else if (paymentDate === '') {
      setUiMessage('err', 'Payment date is empty!');
    } else if (paymentFor === '') {
      setUiMessage('err', 'Please select payment for!');
    } else if (charges === 0.0) {
      setUiMessage('err', 'Please enter Charges!');
    } else if (mode === '') {
      setUiMessage('err', 'Mode is not selected!');
    } else if (check === '') {
      setUiMessage('err', 'Check number is empty!');
    } else if (amount === 0.0) {
      setUiMessage('err', 'Please enter Amount!');
    } else {
      allData.dos = dos;
      allData.paymentDate = paymentDate;
      allData.chargers = charges;
      allData.mode = mode;
      allData.check = check;
      allData.amount = amount;
      allData.due = dueAmount;
      allData.paymentFor = paymentFor;
    }
  };

  const handleServicesClick = () => {
    const text = `Payment for: ${paymentFor}
Due Amount: ${dueAmountTxt}
Payment Amount: ${payAmount}
Unit: ${billType === '1' ? unit : ''}`;
    setServiceTextVal(text);
    setServicesPopup(true);
  };

  return (
    <div className="modalBackground">
      <div className="appt-hx-contnr take-pymnt-main-con qhide">
        <div className="appt-hx-hdr-pt-info">
          <span className="rc-pt-nm">
            Kashif, Mohd <span className="red">|</span> ID: 1162{' '}
            <span className="red">|</span> 25 yrs-[F]{' '}
            <span className="red">|</span> DOB:06-30-1992
          </span>
          <span className="right red bold" onClick={closePopup}>
            X
          </span>
        </div>
        <div className="appt-hx-pc-body">
          <div className="appt-hx-rw-lt">
            <div className="appt-hx-rw hdng-label">
              <span className="label">Take Payment</span>
              <span className="sep red">|</span>
              <span className="label" onClick={handlePaymentHxPopup}>
                <Link>Payment Hx</Link>
              </span>
            </div>
            {/* <div className="appt-hx-rw">
              <span className="tp-label">Mode:</span>
              <span className="tp-val">
                <select
                  className="dd-width"
                  onChange={(e) => setMode(e.target.value)}
                >
                  {modeArr?.map((item, i) => {
                    return (
                      <option key={i} value={item}>
                        {item}
                      </option>
                    );
                  })}
                </select>
              </span>
            </div> */}
            <span className="col1-wdgt-bdy-val tp-pymnt-selecn">
              <span className="left width100 bold">
                <input
                  type="radio"
                  value="0"
                  id="billsradio"
                  name="billMiscRadio"
                  checked={billType === '0'}
                  onChange={() => setBillType('0')}
                />
                &nbsp;For Services
                <input
                  className="clear-left5"
                  type="radio"
                  value="1"
                  id="miscradio"
                  name="billMiscRadio"
                  checked={billType === '1'}
                  onChange={() => setBillType('1')}
                />
                &nbsp; For Miscellaneous
              </span>
            </span>
            <div className="appt-hx-rw">
              <span className="tp-label">Mode:</span>
              <span className="tp-val">
                <span className="left">
                  <input
                    type="radio"
                    value="1"
                    id="cashradio"
                    name="methodRadio"
                    onChange={(e) => setMode(e.target.value)}
                    checked={mode === '1'}
                  />
                  &nbsp;Cash
                  <input
                    className="clear-left5"
                    type="radio"
                    value="2"
                    id="cardradio"
                    name="methodRadio"
                    onChange={(e) => setMode(e.target.value)}
                    checked={mode === '2'}
                  />
                  &nbsp;Card
                  <input
                    className="clear-left5"
                    type="radio"
                    value="3"
                    id="checkradio"
                    name="methodRadio"
                    onChange={(e) => setMode(e.target.value)}
                    checked={mode === '3'}
                  />
                  &nbsp;Check
                </span>
              </span>
            </div>
            <div className="appt-hx-rw">
              <span className="tp-label">Check#:</span>
              <span className="tp-val">
                <input
                  type="text"
                  className="inpt-width"
                  placeholder="Last four digit only..."
                  onChange={(e) => setCheck(e.target.value)}
                />
              </span>
            </div>
            {mode === '2' && (
              <div className="appt-hx-rw">
                <span className="">For documenting only, no transaction:</span>
                <span className="tp-val">
                  <input
                    type="checkbox"
                    className="inpt-width"
                    checked={forDoc}
                    onChange={() => setForDoc(!forDoc)}
                  />
                </span>
              </div>
            )}
            <div className="appt-hx-rw">
              <span className="tp-label">Date of service:</span>
              <span className="tp-val">
                <select
                  className="dd-width"
                  onChange={(e) => setDos(e.target.value)}
                >
                  {dosArr?.map((item, i) => {
                    return (
                      <option key={i} value={item}>
                        {item}
                      </option>
                    );
                  })}
                  {/* <option value="">02-05-2023 (Office)</option>
                  <option value="">02-02-2023 (Lab)</option>
                  <option value="">01-25-2023 (Lab)</option> */}
                </select>
              </span>
            </div>
            <div className="appt-hx-rw">
              <span className="tp-label">Payment date:</span>
              <span className="tp-val" style={{ display: 'flex' }}>
                <input
                  type="text"
                  className="apptDate"
                  placeholder="mm-dd-yyyy"
                  value={paymentDate}
                  onChange={(e) => setPaymentDate(e.target.value)}
                />
                <ReactDatePicker
                  selected={new Date()}
                  onChange={(date) => handleDateChange(date)}
                  customInput={
                    <img
                      src={'./images/calendar-icon.png'}
                      alt="Calendar"
                      width={'30px'}
                    />
                  } // Use the image as the custom input
                  dateFormat={DEFAULT_DATE_FORMATE}
                />
              </span>
            </div>
            <div className="appt-hx-rw">
              <span className="tp-label">
                Payment for:<span className="required-fld">*</span>
              </span>
              <span className="tp-val">
                <select
                  className="dd-width"
                  onChange={(e) => setPaymentFor(e.target.value)}
                >
                  <option value=""></option>
                  <option value="Dues">Dues</option>
                  <option value="Counseling">Counseling</option>
                  {Object.keys(addPaymentArr).map((item, i) => {
                    return (
                      <option key={i} value={addPaymentArr?.item}>
                        {item}
                      </option>
                    );
                  })}
                </select>
                <span className="add-new-value" onClick={handleAddPaymentPopup}>
                  +
                </span>
              </span>
            </div>
            <div className="appt-hx-rw">
              <span className="tp-label">Due Amount($):</span>
              <span className="tp-val">
                <input
                  type="text"
                  className="inpt-width"
                  placeholder="$0.00"
                  maxLength={12}
                  // pattern="[0-9]*"
                  // oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                  onBlur={handleChargesBlur}
                />
              </span>
            </div>

            <div className="appt-hx-rw">
              <span className="tp-label">
                Payment Amount($):<span className="required-fld">*</span>
              </span>
              <span className="tp-val">
                <input
                  type="text"
                  className="inpt-width"
                  placeholder="$0.00"
                  maxLength={12}
                  onBlur={handleAmountBlur}
                />
              </span>
            </div>
            {/* <div className="appt-hx-rw">
              <span className="tp-label">Due ($):</span>
              <span className="tp-val clear-top5">
                {`${dueAmount < 0 ? '-' : ''}$${
                  dueAmount
                    ? Math.abs(parseFloat(dueAmount)).toFixed(2)
                    : '0.00'
                }`}
              </span>
            </div> */}
            {billType === '1' && (
              <div className="appt-hx-rw">
                <span className="tp-label">Unit:</span>
                <span className="tp-val clear-top5">
                  <input
                    style={{ width: '33px' }}
                    type="text"
                    maxLength={3}
                    value={unit}
                    onChange={(e) => setUnit(e.target.value)}
                  />
                </span>
              </div>
            )}
            <div className="appt-hx-rw">
              <span className="tp-label">Services:</span>
              <span className="tp-val clear-top5">
                <span className="link-color" onClick={handleServicesClick}>
                  Click here
                </span>
              </span>
            </div>
            <div className="appt-hx-rw">
              <span className="tp-label">Remark:</span>
              <span className="tp-val clear-top5">
                <textarea
                  style={{ width: '90%', height: '65px' }}
                  placeholder="Write the remark here..."
                  value={remark}
                  onChange={(e) => setRemark(e.target.value)}
                />
              </span>
            </div>
          </div>
          <div className="appt-hx-rw-rt">
            <div className="appt-hx-rw">
              <span
                className=" hdng-label"
                style={{ marginRight: 0, paddingLeft: 15, width: '100%' }}
              >
                Billing Summary
              </span>
            </div>
            <fieldset>
              <legend>Insurance:</legend>
              <div className="appt-hx-rw">
                <span className="bil-smry-col">
                  <span className="tp-label">Charges:</span>
                  <span className="tp-val">$62,586.97</span>
                </span>
                <span className="bil-smry-col">
                  <span className="tp-label">Pay:</span>
                  <span className="tp-val">$12,888.67</span>
                </span>
                <span className="bil-smry-col">
                  <span className="tp-label">Adj:</span>
                  <span className="tp-val">$46,962.21</span>
                </span>
                <span className="bil-smry-col">
                  <span className="tp-label">Bal:</span>
                  <span className="tp-val red">$3,056.96</span>
                </span>
              </div>
            </fieldset>
            <fieldset>
              <legend>Patient:</legend>
              <div className="appt-hx-rw">
                <span className="bil-smry-col">
                  <span className="tp-label">Charges:</span>
                  <span className="tp-val">$165.19 </span>
                </span>
                <span className="bil-smry-col">
                  <span className="tp-label">Pay:</span>
                  <span className="tp-val">$0.00</span>
                </span>
                <span className="bil-smry-col">
                  <span className="tp-label">Adj:</span>
                  <span className="tp-val">$0.00</span>
                </span>
                <span className="bil-smry-col">
                  <span className="tp-label">Bal:</span>
                  <span className="tp-val red">$165.19</span>
                </span>
              </div>
            </fieldset>
            <div
              className="appt-hx-rw hdng-label"
              style={{ width: '100%' }}
              // style={{ borderTop: '0px solid #fff' }}
            >
              <span className="" style={{ width: '100%', paddingLeft: 15 }}>
                <Link href="#">Statement Hx</Link>
              </span>
            </div>
          </div>
        </div>
        {mode === '2' && (
          <div className=" left width100">
            <div className="">
              <input
                className="clear-left5"
                type="radio"
                value="0"
                onChange={() => setCardMode('0')}
                checked={cardMode === '0'}
              />{' '}
              Cards On File
              <input
                className="clear-left5"
                type="radio"
                value="1"
                onChange={() => setCardMode('1')}
                checked={cardMode === '1'}
              />{' '}
              Card Present
            </div>
            <div className="tp-col1-wdgt-sbhdr">
              Saved Cards:
              <span className="add-new-cc hide">Add new card</span>
              <span className="right clear-right">
                <Link>[Add new card]</Link>
              </span>
            </div>
            <div className="cc-saved-crds-bdy">
              <input type="hidden" id="deviceExternalId" value="" />
            </div>
          </div>
        )}
        {/* <div>
          <br />
        </div> */}
        {/* <div className="appt-hx-rw" style={{ borderTop: '4px solid #fff' }}>
          <span className="label" style={{ width: '80%', paddingLeft: 15 }}>
            <a href="#">Statement Hx</a>
          </span>
        </div> */}
        <div className="appt-hx-rw apt-hx-btn-rw">
          {/* <button className="actn-yes" style={{ width: '25%' }}>
            Save & Print
          </button> */}
          <button className="actn-yes" onClick={handleSave}>
            Take Payment {payAmount}
          </button>
          {/* <button className="actn-No" onClick={closePopup}>
            Cancel
          </button> */}
        </div>
      </div>
      {servicesPopup && (
        <div style={{ zIndex: '999', backgroundColor: 'wheat' }}>
          <span>
            <span className="tp-services-con-hdr">
              <div className="left">Services:</div>
              <span
                className="right bold red cursor"
                onClick={() => setServicesPopup(false)}
              >
                X
              </span>
            </span>
            <textarea
              className="clear-left5"
              id="services"
              placeholder="Write the Services here"
              style={{ width: 'calc(100% - 14px)', height: '160px' }}
              value={serviceTextVal}
              onChange={(e) => setServiceTextVal(e.target.value)}
            ></textarea>
            <span className="tp-services-con-ftr">
              <span
                className="right button-cancel"
                onClick={() => setServicesPopup(false)}
              >
                Close
              </span>
            </span>
          </span>
        </div>
      )}
      {addPaymentPopup && (
        <AddPaymentPopup
          addPaymentArr={addPaymentArr}
          setAddPaymentArr={setAddPaymentArr}
          closePopup={() => setAddPaymentPopup(false)}
        />
      )}
      {paymentHxPopup && (
        <PaymentHxPopup closePopup1={() => setPaymentHxPopup(false)} />
      )}
    </div>
  );
}

export default TakePaymentPopUp;
